/**
 * Builds the CloudFormation quick-create URL that the wizard's Bedrock launch
 * action opens. The Bedrock ingestion stack deploys in a single region
 * (us-east-1 by default) — member accounts are auto-discovered via AWS
 * Organizations at sync time.
 *
 * Returns `null` when any required input is missing — caller renders an
 * unavailable state rather than emit a broken URL.
 */
export interface AwsBedrockLaunchUrlInputs {
    cfnTemplateUrl: string;
    platformAccountId: string;
    cloudFormationStackName: string;
    consoleHostTemplate: string;
    externalId: string;
}

const STACK_REGION = 'us-east-1';

export function buildAwsBedrockLaunchUrl(inputs: AwsBedrockLaunchUrlInputs): string | null {
    const { cfnTemplateUrl, platformAccountId, cloudFormationStackName, consoleHostTemplate, externalId } = inputs;

    if (!cfnTemplateUrl || !platformAccountId || !externalId) {
        return null;
    }

    const host = consoleHostTemplate.replace('{region}', STACK_REGION);
    const params = new URLSearchParams({
        templateURL: cfnTemplateUrl,
        stackName: cloudFormationStackName,
        param_ExternalId: externalId,
        param_PlatformAccountId: platformAccountId,
    });
    return `https://${host}/cloudformation/home?region=${STACK_REGION}#/stacks/quickcreate?${params.toString()}`;
}

export const AWS_BEDROCK_PROVIDER_TYPE_ID = 'aws-bedrock/invocation-logs@1.0.0';
export const AWS_BEDROCK_BUILD_LAUNCH_URL_ROUTE = 'buildLaunchUrl';
